module.exports = __webpack_public_path__ + "img/25.a275ec80.jpg";